<template>
  <div class="rtl">
    <m-form
        :title="title"
        :items="items"
        :cols="cols"
        :isEditing.sync="isEditing"
        :canDelete="canDelete"
        :canSubmit="canSubmit"
        :show-navigation-btns="false"
        :showListBtn="false"
        @click:row="setItem"
        @clearForm="clearForm"
        @submit="submit"
        @delete="deleteItem"
    >
      <template #header-btns>
        <v-tooltip top color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                depressed
                small
                v-bind="attrs"
                v-on="on"
                v-if="!isInvitation"
                class="primary white--text mr-2 ml-2 mt-md-0 rounded-lg"
                :to="{ name: 'ExtendPlan' }"
            >ارتقا اشتراک
            </v-btn>
          </template>
          ارتقا یا تمدید اشتراک
        </v-tooltip>
        <v-tooltip top color="secondary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                depressed
                small
                v-bind="attrs"
                v-on="on"
                v-if="!isInvitation"
                class="secondary white--text mr-2 ml-2 mt-md-0 rounded-lg"
                :to="{ name: 'Users' }"
            >کاربران
            </v-btn>
          </template>
          نمایش کاربران
        </v-tooltip>
      </template>

      <template #default>
        <v-row>
          <v-col cols="12" md="6">
            <m-national-code @change="searchUser(item.username)" class="rounded-lg" label="* کد ملی " v-model="item.username" :disabled="!isEditing"/>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
                class="rounded-lg"
                label="* کد تایید"
                v-model="item.confirmation_code"
                :disabled="!isEditing"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
                class="rounded-lg"
                label="نام و نام خانوادگی"
                v-model="name"
                :disabled="true"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field class="rounded-lg" label="نام نمایشی جهت خروجی ها"
                          v-model="item.nickname" :disabled="!isEditing"/>
          </v-col>


          <v-col cols="12">
            <v-autocomplete
                class="rounded-lg"
                :return-object="false"
                label="سال های مالی"
                :items="financialYears"
                v-model="item.financialYears"
                :disabled="!isEditing"
                item-text="name"
                item-value="id"
                multiple
            ></v-autocomplete>
          </v-col>

          <v-col cols="12">
            <v-autocomplete
                class="rounded-lg"
                :return-object="false"
                label="نقش ها"
                :items="roles"
                v-model="item.roles"
                :disabled="!isEditing"
                item-text="name"
                item-value="id"
                multiple
            ></v-autocomplete>
          </v-col>
        </v-row>
      </template>
    </m-form>
  </div>
</template>
<script>
import {MFormMixin} from "@/components/m-form";
import getRolesApi from "../role/getRolesApi";
import UserApi from "@/views/panel/user/api";
import CompanyMixin from "@/views/panel/company/mixin";
import AuthMixin from "@/views/auth/mixin";

export default {
  mixins: [MFormMixin, getRolesApi, UserApi, CompanyMixin, AuthMixin],
  props: {
    isInvitation: {
      default: false,
    },
  },
  data() {
    return {
      baseUrl: "companies/companyUserInvitations",
      appendSlash: true,
      name: null,
      roles: [],
      items: [],
      financialYears: [],
      permissionBasename: "user",
    };
  },
  computed: {
    title() {
      return "ثبت دعوت نامه";
    },
    cols() {
      return [
        {
          text: "کد ملی",
          value: "username",
        },
        {
          text: "کد تایید",
          value: "confirmation_code",
        },
        {
          text: "وضعیت",
          value: "status",
          type: "select",
          items: this.UserInvitationStatuses,
        },
      ];
    },
  },
  methods: {
    searchUser(username) {
      if (username.length == 10) {
        this.request({
          url: this.endpoint(`users/search/${username}/`),
          method: "get",
          success: (data) => {
            this.name = data.first_name + ' ' + data.last_name
          },
          error: data => {
            this.name = ''
            this.notify('کد ملی در سامانه ثبت نام نکرده', 'danger')
          }
        });
      } else {
        this.name = ''
        this.notify('کد ملی صحیح نیست', 'danger')
      }
    },
    getItemTemplate() {
      return {
        id: null,
        roles: [],
        financialYears: [],
      };
    },
    getData() {
      this.getCompanyUserInvitations((data) => {
        this.items = data;
      });
      this.getRoles((data) => (this.roles = data));
      this.getFinancialYears((data) => (this.financialYears = data));
    },
  },
};
</script>
